<template>
  <Link
    :href="href"
    class="flex items-center gap-2 px-6 py-2.5 text-sm transition-colors hover:bg-bay"
    :class="{ 'bg-bay font-semibold text-main': active }"
  >
    <span
      v-if="icon"
      class="material-symbols-outlined shrink-0"
      style="font-size: 1.15rem"
    >{{ icon }}</span>
    <span class="flex-1 truncate">{{ label }}</span>
  </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  components: { Link },
  props: {
    href: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: String, default: '' },
    active: { type: Boolean, default: false },
  },
}
</script>
